var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeactivateicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_530_9246)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.1129 14.6572C44.9039 11.7991 43.1738 9.2326 40.9708 7.02966C38.7679 4.82672 36.2014 3.09662 33.3433 1.88755C30.3822 0.63507 27.2388 0 24 0C20.7612 0 17.6178 0.63507 14.6572 1.88755C11.7986 3.09662 9.2326 4.82672 7.02966 7.02966C4.82672 9.2326 3.09662 11.7991 1.88755 14.6572C0.63507 17.6178 0 20.7612 0 24C0 27.2388 0.63507 30.3822 1.88708 33.3428C3.09614 36.2014 4.82624 38.7674 7.02919 40.9703C9.23213 43.1733 11.7986 44.9034 14.6567 46.1124C17.6173 47.3649 20.7607 47.9995 23.9995 47.9995C27.2383 47.9995 30.3817 47.3645 33.3423 46.1124C36.2009 44.9034 38.7669 43.1733 40.9699 40.9703C43.1728 38.7674 44.9029 36.2009 46.112 33.3428C47.3645 30.3822 47.999 27.2388 47.999 24C47.999 20.7612 47.364 17.6178 46.112 14.6572H46.1129ZM11.447 11.447C14.7998 8.09416 19.2582 6.24716 24 6.24716C27.6835 6.24716 31.1952 7.36175 34.1516 9.43109L9.43109 34.1511C7.36223 31.1952 6.24716 27.683 6.24716 24C6.24716 19.2582 8.09368 14.7998 11.447 11.447ZM36.553 36.553C33.2002 39.9058 28.7418 41.7528 24 41.7528C20.3165 41.7528 16.8048 40.6383 13.8489 38.5689L38.5689 13.8484C40.6378 16.8043 41.7528 20.3165 41.7528 24C41.7528 28.7418 39.9063 33.2002 36.553 36.553Z",
    fill: "#F95858"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_530_9246"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeactivateicon);
export default __webpack_public_path__ + "static/media/deactivateicon.a14ddbfaeab7c14020626bb1abcb7916.svg";
export { ForwardRef as ReactComponent };